import { UserPlus, FileText, MapPin, Search, FileCheck, Archive } from "lucide-react";
const pasos = [{
  num: "01",
  icon: UserPlus,
  title: "Alta del cliente",
  desc: "Capturas los datos básicos del cliente o usuario. El sistema identifica el tipo de operación y la fracción del Art. 17 que aplica."
}, {
  num: "02",
  icon: FileText,
  title: "Documentos de identidad",
  desc: "Subes INE, pasaporte o documento equivalente. En planes Pro, el OCR extrae los datos automáticamente para reducir errores de captura."
}, {
  num: "03",
  icon: MapPin,
  title: "Verificación de domicilio",
  desc: "Registras y validas el domicilio del cliente con el comprobante correspondiente, conforme a los requisitos de identificación."
}, {
  num: "04",
  icon: Search,
  title: "Screening de listas",
  desc: "El sistema coteja al cliente contra listas PEP, OFAC, ONU y SAT 69-B. Si hay coincidencia, te alerta antes de continuar."
}, {
  num: "05",
  icon: FileCheck,
  title: "Generación del expediente",
  desc: "Con un clic, generas la ficha KYC en PDF con todos los anexos y el resultado del screening, en el formato que exige la autoridad."
}, {
  num: "06",
  icon: Archive,
  title: "Resguardo y monitoreo",
  desc: "El expediente se archiva en la bóveda cifrada por 10 años, con bitácora auditable y monitoreo continuo del perfil del cliente."
}];
export default function FlujoKyc() {
  return <section data-section-id="REEMPLAZAR" id="flujo" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 flex flex-col items-center text-center">
          <h2 className="font-default text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
            El flujo KYC, <span className="text-primary font-mono">paso a paso</span>
          </h2>
          <p className="mt-4 max-w-[800px] text-lg text-slate-400 font-default">
            Un recorrido guiado que cualquier miembro de tu equipo puede seguir, sin formación legal previa.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {pasos.map((paso, i) => {
          const Icon = paso.icon;
          return <div key={paso.num} data-index={i} className="relative p-6 rounded-lg bg-card border border-border hover:border-primary/50 transition-all duration-200">
                <div className="flex items-center justify-between mb-4">
                  <div className="size-12 rounded-md bg-primary/10 flex items-center justify-center">
                    <Icon className="size-6 text-primary" strokeWidth={1.5} />
                  </div>
                  <span className="font-mono text-3xl font-extrabold text-primary/20">{paso.num}</span>
                </div>
                <h3 className="font-default text-lg font-bold text-white mb-2">{paso.title}</h3>
                <p className="font-default text-sm text-slate-400 leading-relaxed">{paso.desc}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}